import { Award } from 'types/Search';

export interface AwardDisplayProps {
  award: Award;
  size: SizingOptions;
}

export enum SizingOptions {
  SMALL = 'sm',
  MEDIUM = 'md',
  LARGE = 'lg'
}
